import React, { useState, useReducer, useEffect } from "react"
import {
  Box,
  Button
} from "@mui/material"


const ResetPackage = ({ rowData, mainProps, setErrorMessage }) => {



  return (
    <Box>
      <Button
        color="primary"
        size="small"
        disabled={!rowData.packageNeed}
        onClick={async () => {
            const { onResetPackage } = mainProps
            const message = rowData.packageSerialNumber?`serial:${rowData.packageSerialNumber}`:''
            if(window.confirm("آیا سریال پکیج ریست شود" + message)){
                await onResetPackage(rowData.idGasProject)
            }
           
        }}
      >
        ریست پکیج
      </Button>
    </Box>
  )
}

export default ResetPackage
